module.exports = __webpack_public_path__ + "fonts/BentonSansBBVA-MediumItalic.6d903841.woff2";